/* eslint-disable eqeqeq */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { BsSearch } from 'react-icons/bs';
import MasterKelurahanController, {
  useMasterKelurahanContext,
} from '../../../../controller/admin/data_master/kelurahan';
import DataTable from 'react-data-table-component';
import ReactLoading from 'react-loading';
import { If, Then, Else } from 'react-if';
import { AiFillPlusCircle } from 'react-icons/ai';
import { ToastContainer } from 'react-toastify';
import Select from 'react-select';
import SidebarWithHeader from '../../../../components/Admin/SidebarWithHeader';
import { Box } from '@chakra-ui/react';
import MasterKabupatenContext, {
  useMasterKabupatenContext,
} from '../../../../controller/admin/data_master/kabupaten';
import { useRole } from '../../../../../hooks/useRole';

const ModalCreateData: React.FC = () => {
  const {
    formDialog,
    formKecamatanId,
    formNameKelurahan,
    formLoading,
    showDialog,
    kecamatan,
    valueKabupaten,
  } = useMasterKelurahanContext().state;
  const {
    actionFormDialog,
    setFormNameKelurahan,
    setFormKecamatanId,
    setShowDialog,
    getKecamatanByKabupatenId,
    setValueKabupaten,
  } = useMasterKelurahanContext();

  const { getKabupaten } = useMasterKabupatenContext();
  const { kabupaten } = useMasterKabupatenContext().state;

  const optionsKabupaten = kabupaten.map((item) => {
    return { value: item.id.toString(), label: item.nama_kabupaten };
  });

  useEffect(() => {
    if (valueKabupaten?.value) {
      getKecamatanByKabupatenId(valueKabupaten.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueKabupaten]);

  useEffect(() => {
    getKabupaten(1, '', 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let optionsKecamatan;
  let valueKecamatan;

  if (kecamatan.length > 0) {
    optionsKecamatan = kecamatan.map((item) => ({
      value: item.id,
      label: item.nama_kecamatan,
    }));
    if (formKecamatanId != '') {
      kecamatan.map((item) => {
        if (item.id == Number(formKecamatanId)) {
          valueKecamatan = { value: item.id, label: item.nama_kecamatan };
        }

        return valueKecamatan;
      });
    }
  } else {
    optionsKecamatan = [];
  }

  return (
    <>
      {showDialog ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-3xl p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {formDialog} Kelurahan
                  </h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialog(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2">
                  <div className="form-group grid-cols-6">
                    <label className="form-label inline-block py-1.5 text-gray-700 font-medium col-span-2">
                      Kabupaten
                    </label>
                    <Select
                      className="w-full col-span-4"
                      options={optionsKabupaten}
                      value={valueKabupaten}
                      onChange={(val) => setValueKabupaten(val)}
                      placeholder="Pilih Kecamatan"
                    />
                  </div>

                  <div className="form-group grid-cols-6">
                    <label className="form-label inline-block py-1.5 text-gray-700 font-medium col-span-2">
                      Kecamatan
                    </label>
                    <Select
                      className="w-full col-span-4"
                      options={optionsKecamatan}
                      value={valueKecamatan}
                      onChange={(val: any) => setFormKecamatanId(val.value)}
                      placeholder="Pilih Kecamatan"
                    />
                  </div>

                  <div className="form-group grid-cols-6">
                    <label className="form-label inline-block py-1.5 text-gray-700 font-medium col-span-2">
                      Kelurahan
                    </label>
                    <input
                      type="text"
                      className="
                    form-control
                    col-span-4
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    transition
                    ease-in-out
                    m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                    "
                      placeholder="Masukkan Kelurahan"
                      onChange={(event) =>
                        setFormNameKelurahan(event.target.value)
                      }
                      value={formNameKelurahan}
                    />
                  </div>
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-end -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialog(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-green-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => actionFormDialog()}
                  >
                    <If condition={formLoading}>
                      <Then>
                        <ReactLoading
                          type={'bars'}
                          color={'white'}
                          height={15}
                          width={20}
                        />
                      </Then>
                      <Else>Simpan</Else>
                    </If>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const ModalDelete: React.FC = () => {
  const { showDialogDelete, formLoading } = useMasterKelurahanContext().state;
  const { setShowDialogDelete, deleteKelurahan } = useMasterKelurahanContext();

  return (
    <>
      {showDialogDelete ? (
        <>
          {/* Background Modal */}
          <div className="opacity-25 fixed inset-0 z-40 bg-black w-full "></div>

          {/* Modal */}
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full h-full max-w-3xl p-4 md:h-auto">
              <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                {/* Modal content */}
                <div className="flex items-start justify-between p-4 rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    Hapus Kelurahan
                  </h3>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent bg-red-400 hover:bg-red-600 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    onClick={() => setShowDialogDelete(false)}
                    style={{ color: 'white' }}
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                <div className="p-6 space-y-6 -mt-2">
                  Apakah Anda Yakin Ingin Menghapus Data Ini?
                </div>
                <div className="items-center p-6 space-x-2 rounded-b flex justify-end -mt-3">
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-gray-400 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-500 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                    onClick={() => setShowDialogDelete(false)}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className="inline-block px-6 py-2.5 bg-red-500 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    onClick={() => deleteKelurahan()}
                  >
                    <If condition={formLoading}>
                      <Then>
                        <ReactLoading
                          type={'bars'}
                          color={'white'}
                          height={15}
                          width={20}
                        />
                      </Then>
                      <Else>Yakin</Else>
                    </If>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

const WrapperMain: React.FC = () => {
  const {
    getKelurahan,
    searchKelurahan,
    setPageRow,
    setFormDialog,
    setShowDialog,
    setUpdate,
    setShowDialogDelete,
    setValueKabupaten,
  } = useMasterKelurahanContext();
  const { kelurahan, isLoading, keyword } = useMasterKelurahanContext().state;
  const { kabupaten } = useMasterKabupatenContext().state;
  const [perPage, setPerPage] = useState(10);
  const { canMutate } = useRole();
  const [filterText] = React.useState('');
  const [resetPaginationToggle] = React.useState(false);

  const optionsKabupaten = kabupaten.map((item) => {
    return { value: item.id.toString(), label: item.nama_kabupaten };
  });

  const columns = [
    {
      name: 'No.',
      selector: (row, index) => index + 1,
      grow: 0,
    },
    {
      name: 'Kelurahan',
      selector: (row) => row.nama_kelurahan,
      sortable: true,
    },
    ...(canMutate
      ? [
          {
            name: 'Action',
            selector: (row) => {
              return (
                <div>
                  <button
                    className="ml-2 px-2 py-1 text-xs text-green-700 bg-green-100 rounded-full hover:bg-green-200"
                    onClick={() => {
                      setFormDialog('Ubah');
                      setShowDialog(true);
                      const kabupatenSelected = optionsKabupaten.find(
                        (item) => item.value === row.kabupaten_id.toString()
                      );
                      setValueKabupaten(kabupatenSelected);
                      setUpdate(row);
                    }}
                  >
                    Ubah Data
                  </button>
                  <button
                    className="ml-2 px-2 py-1 text-xs text-red-700 bg-red-100 rounded-full hover:bg-red-200"
                    onClick={() => {
                      setShowDialogDelete(true);
                      setUpdate(row);
                    }}
                  >
                    Hapus Data
                  </button>
                </div>
              );
            },
            sortable: true,
          },
        ]
      : []),
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#F2FFFB',
        fontWeight: '600',
        fontSize: '13px',
      },
    },
  };

  useEffect(() => {
    getKelurahan(1, '', 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    getKelurahan(page, keyword, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    getKelurahan(page, keyword, newPerPage);
    setPerPage(newPerPage);
    setPageRow(newPerPage);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="flex flex-row justify-between w-full items-center">
        <p className="font-semibold text-base">Kelurahan</p>
        <div className="flex flex-wrap">
          <div className="input-group relative flex flex-wrap mr-2">
            <button
              className="btn px-3 py-1 border border-gray-300 text-[#212529] text-lg leading-tight uppercase rounded hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
              style={{ height: '38px' }}
            >
              <BsSearch />
            </button>
            <input
              type="search"
              className="form-control relative flex-auto min-w-0 block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white  border border-solid border-gray-300 rounded focus:ring-0 focus:border-gray-300"
              placeholder="Search"
              onChange={(event) => searchKelurahan(event.target.value)}
            />
          </div>
          {canMutate && (
            <button
              type="button"
              className="px-6 py-2.5 bg-green-400 text-white font-medium text-xs rounded flex flex-row items-center hover:bg-green-500"
              style={{ height: '38px' }}
              onClick={() => {
                setValueKabupaten(null);
                setFormDialog('Tambah');
                setShowDialog(true);
              }}
            >
              Tambah Baru <AiFillPlusCircle className="ml-3" />
            </button>
          )}
        </div>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterText, resetPaginationToggle]);

  const CustomLoader = () => (
    <div style={{ padding: '24px' }}>
      <ReactLoading type={'bars'} color={'green'} height={100} width={100} />
      <div>Loading Data...</div>
    </div>
  );

  return (
    <SidebarWithHeader title="Master Kelurahan">
      <Box className="app">
        <ModalCreateData />
        <ModalDelete />

        <Box as="main" style={{ padding: '0px' }}>
          <Box className="container">
            <Box bg="white" p={5} borderRadius="lg" mb={5} shadow="lg">
              <DataTable
                columns={columns}
                data={kelurahan}
                progressPending={isLoading}
                pagination
                paginationServer
                paginationTotalRows={
                  kelurahan.length > 0 ? kelurahan[0].jumlahData : 0
                }
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                customStyles={customStyles}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                progressComponent={<CustomLoader />}
                noDataComponent="Tidak ada data"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </SidebarWithHeader>
  );
};

const MasterKelurahan: React.FC = () => {
  return (
    <MasterKabupatenContext.Provider>
      <MasterKelurahanController.Provider>
        <ToastContainer
          position="top-center"
          style={{ width: '60%', marginTop: '5%' }}
        />
        <WrapperMain />
      </MasterKelurahanController.Provider>
    </MasterKabupatenContext.Provider>
  );
};

export default MasterKelurahan;
